import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingComponent } from '../../../shared/components/loader/loading/loading.component';

@Component({
   selector: 'app-layout-login',
   standalone: true,
   imports: [RouterOutlet, LoadingComponent],
   templateUrl: './layout-login.component.html',
})
export class LayoutLoginComponent {}
